import React, { useState } from "react";
import ModalCustomPallete from "./modals/ModalCustomPallete";
import ModalEditPhoto from "./modals/ModalEditPhoto";
import { stars } from "../assets";

const DisplayCard = ({
  templates,
  indexTemplate,
  setIndexTemplate,
  colorThemes,
  setColorThemes,
  setColorSecond,
  setColorFirst,
  inputFile1,
  inputFile2,
  inputFile3,
  handleOnChangeImage,
  onButtonClick,
  onDeletePhoto,
  imageSourceHeader,
  imageSourceProfile,
  imageSourceLogo,
  indexColorTheme,
  setIndexColorTheme,
  imageEdit,
  funcSetEdit,
  aspect,
  circularCrop,
}) => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const package_ = user.package.slug;
  const setHandleColorTheme = (ind, color1, color2) => {
    setIndexColorTheme(ind);
    if (color1 && color2) {
      setColorSecond(color2);
      setColorFirst(color1);
      return;
    }
    setColorSecond(colorThemes[ind].color2);
    setColorFirst(colorThemes[ind].color1);
  };
  const setTemplate = (ind) => {
    setIndexTemplate(ind);
  };

  // console.log(funcSetEdit);

  return (
    <div className="flex flex-col px-5 pt-5 pb-52 md:py-5 gap-5 w-full overflow-y-auto">
      <div className="flex flex-col gap-2">
        <div className="font-bold">Color Theme</div>
        <div className="grid grid-cols-3 gap-2">
          {colorThemes.map((val, ind) => {
            return (
              <div
                key={ind}
                className={`flex flex-col w-full items-center ${
                  ind == indexColorTheme ? "bg-gray-200" : ""
                } px-2 py-3 gap-3 rounded-md cursor-pointer`}
                onClick={() => {
                  if (ind < 5) {
                    setHandleColorTheme(ind);
                  } else {
                    document.getElementById("pallete_modal").showModal();
                  }
                }}
              >
                <div className="flex flex-row w-full h-10">
                  <div
                    className="flex w-1/2"
                    style={{ backgroundColor: val.color1 }}
                  ></div>
                  <div
                    className="flex w-1/2"
                    style={{ backgroundColor: val.color2 }}
                  ></div>
                </div>
                <div>{val.name}</div>
              </div>
            );
          })}
          {colorThemes.length < 6 ? (
            <div
              className={`flex flex-col w-full items-center px-2 py-3 gap-3 rounded-md`}
            >
              <div
                className="flex flex-row w-full h-10 items-center justify-center border border-gray-200 hover:bg-gray-300 cursor-pointer relative"
                onClick={() =>
                  document.getElementById("pallete_modal").showModal()
                }
              >
                <div>+</div>
                {package_.toLowerCase().includes("free") ? (
                  <img
                    src={stars}
                    alt=""
                    className="absolute w-5 h-5 -top-2 -right-2"
                  />
                ) : null}
              </div>
              <div>Custom</div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold">Card Template</div>
        <div className="grid grid-cols-5 gap-2">
          {templates.map((val, ind) => {
            return (
              <div
                key={ind}
                className={`flex flex-col w-full items-center ${
                  ind == indexTemplate ? "bg-gray-200" : ""
                } px-2 py-3 gap-3 rounded-md cursor-pointer`}
                onClick={() => setTemplate(ind)}
              >
                <div className="flex flex-col relative">
                  <img src={val.img} alt={val.name} className={`w-full`} />
                  {(ind == 1 || ind == 2) &&
                  package_.toLowerCase().includes("free") ? (
                    <img
                      src={stars}
                      alt=""
                      className="absolute w-5 h-5 -top-2 -right-2"
                    />
                  ) : null}
                </div>
                <div>{val.name}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold">Header</div>
        <input
          type="file"
          accept="image/*"
          id="header"
          ref={inputFile1}
          className="hidden"
          onChange={(e) => handleOnChangeImage(e, "header")}
        />
        <div className="flex flex-col w-full gap-2">
          {imageSourceHeader ? (
            <div className="flex flex-col">
              <img
                src={imageSourceHeader}
                alt="header"
                className="w-[300px] h-[150px]"
              />
            </div>
          ) : null}
          <div className="flex flex-row gap-4">
            <div
              onClick={(e) => {
                if (indexTemplate != 2) {
                  onButtonClick("header");
                }
              }}
              className={`px-4 py-1 ${
                indexTemplate == 2
                  ? "bg-gray-600 cursor-not-allowed"
                  : "bg-primary hover:bg-tertiary cursor-pointer"
              } text-[16px] font-regular text-white w-fit rounded-lg`}
            >
              {imageSourceHeader ? "Edit" : "Upload"}
            </div>
            {imageSourceHeader ? (
              <div
                onClick={(e) => onDeletePhoto("header")}
                className="px-4 py-1 bg-red-900 text-[16px] font-regular cursor-pointer text-white w-fit rounded-lg hover:bg-tertiary"
              >
                Delete
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold">Profile Picture</div>
        <input
          type="file"
          accept="image/*"
          id="profile"
          ref={inputFile2}
          className="hidden"
          onChange={(e) => handleOnChangeImage(e, "profile")}
        />
        <div className="flex flex-col w-full gap-2">
          {imageSourceProfile ? (
            <div className="flex flex-col">
              <img
                src={imageSourceProfile}
                alt="header"
                className="w-[200px]"
              />
            </div>
          ) : null}
          <div className="flex flex-row gap-4">
            <div
              onClick={(e) => onButtonClick("profile")}
              className="px-4 py-1 bg-primary text-[16px] font-regular cursor-pointer text-white w-fit rounded-lg hover:bg-tertiary"
            >
              {imageSourceProfile ? "Edit" : "Upload"}
            </div>
            {imageSourceProfile ? (
              <div
                onClick={(e) => onDeletePhoto("profile")}
                className="px-4 py-1 bg-red-900 text-[16px] font-regular cursor-pointer text-white w-fit rounded-lg hover:bg-tertiary"
              >
                Delete
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold">Company Logo</div>
        <input
          type="file"
          accept="image/*"
          id="logo"
          ref={inputFile3}
          className="hidden"
          onChange={(e) => handleOnChangeImage(e, "logo")}
        />
        <div className="flex flex-col w-full gap-2">
          {imageSourceLogo ? (
            <div className="flex flex-col">
              <img src={imageSourceLogo} alt="header" className="w-[200px]" />
            </div>
          ) : null}
          <div className="flex flex-row gap-4">
            <div
              onClick={(e) => {
                if (indexTemplate != 2) {
                  onButtonClick("logo");
                }
              }}
              className={`px-4 py-1 ${
                indexTemplate == 2
                  ? "bg-gray-600 cursor-not-allowed"
                  : "bg-primary hover:bg-tertiary cursor-pointer"
              } text-[16px] font-regular text-white w-fit rounded-lg`}
            >
              {imageSourceLogo ? "Edit" : "Upload"}
            </div>
            {imageSourceLogo ? (
              <div
                onClick={(e) => onDeletePhoto("logo")}
                className="px-4 py-1 bg-red-900 text-[16px] font-regular cursor-pointer text-white w-fit rounded-lg hover:bg-tertiary"
              >
                Delete
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <ModalCustomPallete
        colorThemes={colorThemes}
        setColorThemes={setColorThemes}
        setHandleColorTheme={setHandleColorTheme}
      />
      <ModalEditPhoto
        imgsrc={imageEdit}
        setImgSrc={funcSetEdit}
        aspect={aspect}
        circularCrop={circularCrop}
      />
    </div>
  );
};

export default DisplayCard;
